import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// ==========================================================
// Component ฉลากสติ๊กเกอร์บาร์โค้ด
// ==========================================================
const DentalLabel = React.forwardRef(({ data, previewMode }, ref) => (
  <div ref={ref} style={{ width: '200px', height: '400px', backgroundColor: 'white', position: 'relative', overflow: 'hidden', border: previewMode ? '2px solid #ccc' : 'none', boxSizing: 'border-box' }}>
    <div style={{ width: '400px', height: '200px', position: 'absolute', top: 0, left: '200px', transformOrigin: '0 0', transform: 'rotate(90deg)', display: 'flex', flexDirection: 'column', padding: '10px 15px', boxSizing: 'border-box', fontFamily: "'Sarabun', sans-serif", color: 'black' }}>
      <div style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center', marginBottom: '8px', width: '100%' }}>ทันตกรรม โรงพยาบาลฝาง</div>
      <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', maxWidth: '250px', gap: '4px' }}>
          <div style={{ fontSize: '28px', fontWeight: '900', lineHeight: '1.2', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.name}</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold', lineHeight: '1.3', marginTop: '2px' }}>
            <div>ผลิต: {data.mfd}</div>
            <div>EXP: <span style={{color: previewMode ? '#d35400' : '#000'}}>{data.exp}</span></div>
          </div>
          <div style={{ fontSize: '14px', lineHeight: '1.3', fontWeight: '600', marginTop: '4px' }}>
            {data.tBox && data.tBox !== '-' ? (
                <div style={{ background: '#000', color: '#fff', padding: '2px 6px', borderRadius: '4px', display: 'inline-block', fontSize: '13px', marginBottom: '2px' }}>📥 กล่อง: {data.tBox}</div>
            ) : (
                <div>เตรียม: {data.prep} | ตรวจ: {data.check}</div>
            )}
            <div>เครื่อง: {data.mac} | รอบ: {data.cyc}</div>
          </div>
        </div>
        <div style={{ width: '130px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <QRCodeCanvas value={data.id} size={110} level="Q" style={{ width: '110px', height: '110px' }} />
          <div style={{ fontSize: '14px', marginTop: '6px', fontFamily: 'monospace', textAlign: 'center', fontWeight: 'bold' }}>{data.id}</div>
        </div>
      </div>
    </div>
  </div>
));

export default DentalLabel;
